import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment.prod';
import { CommonModule } from '@angular/common';
import { CommunicationService } from '../../../core';

@Component({
  selector: 'kt-app-contact-form',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss'
})
export class ContactFormComponent {
  private fb = inject(FormBuilder);
  private communicationService = inject(CommunicationService);
  private env = environment;

  contactForm: FormGroup = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    subject: ['', Validators.required],
    message: ['', Validators.required]
  });

  isLoading = false;
  isSuccess = false;
  isError = false;
  errorMsg = '';

  onSubmit(): void {
    if (this.contactForm.invalid) {
      this.isError = true;
      this.errorMsg = 'Please fill in all required fields.';
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.isError = false;
    this.isSuccess = false;

    const payload = {
      ...this.contactForm.value,
      applicationId: this.env.appId
    };

    this.communicationService.sendContactMessage(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.isSuccess = true;
        this.contactForm.reset();
        this.resetMessages();
      },
      error: (err) => {
        this.isLoading = false;
        this.isError = true;
        this.errorMsg = err.error?.message || 'Something went wrong!';
      }
    });
  }

  private resetMessages(): void {
    setTimeout(() => {
      this.isSuccess = false;
      this.isError = false;
      this.errorMsg = '';
    }, 5000);
  }
}
